import { useEffect, useState } from "react";
import styles from "./TermsCondition.module.scss";
import Swal from "sweetalert2";
import Checkbox from "@mui/material/Checkbox";
import MainHeader from "../../components/Header/MainHeader";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { trackEvent } from "../../lib/google";
import { googleEvent_LOJ167, googleEvent_LOJ170 } from "../../lib/google-analytics";
import { pixelEvents } from "../../lib/pixel-events";
import OtpModal from "../../components/Modal/OtpModal";
import { KFS_OTP } from "../../statusCode/statusCode";
import CustomButton from "../../components/Button/CustomButton";
import { useNavigate } from "react-router-dom";

const label = { inputProps: { "aria-label": "Checkbox" } };

export default function TermsCondition() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [checkTerm, setCheckTerm] = useState(true);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [apiResponseMsg, setApiResponseMsg] = useState();
  const [resendTrigger, setResendTrigger] = useState(0);

  const MAX_RETRIES = 5;
  const navigate = useNavigate();

  const { keyFactAceeptanceAPI } = new AfterOnboardAPI();

  useEffect(() => {
    const fetchAPI = async () => {
      const { keyFactStatementsAPI } = new AfterOnboardAPI();
      const res = await keyFactStatementsAPI();
      if (res && res?.statusCode === 200) {
        setData(res.data);
      } else if (resendTrigger < MAX_RETRIES) {
        setResendTrigger((prev) => prev + 1);
      }
    };

    fetchAPI();
    googleEvent_LOJ167();
  }, [resendTrigger]);

  const handleKeyFactStatus = async (otp) => {
    setLoading(true);
    try {
      const res = await keyFactAceeptanceAPI(otp);
      const { kfsOtpRequest, kfsSuccess } = res.data;
      if (KFS_OTP.kfsOtpRequest === kfsOtpRequest && KFS_OTP.kfsSuccess === kfsSuccess) {
        setOpenOtpModal(true);
        return;
      }
      if (res.statusCode === 203) {
        setApiResponseMsg(res.message);
        return;
      }

      if (res && res.data.status === "1") {
        googleEvent_LOJ170();
        pixelEvents.disbursed();
        setTimeout(() => {
          setLoading(false);

          window.location.href = "/dashboard";
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          text: res.data.message,
        });
        setLoading(false);
      }
      trackEvent({
        action: "KFS",
        category: "term-condition",
        label: "Accepted",
        value: 0,
      });

      if (window.fbq) {
        window.fbq("track", "Lead", {
          value: 1,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="wrapper auto-height">
        <div className="vertical-column-layout">
          <div className="vertical-column-top">
            <MainHeader title="Key Fact Statement" backPageName={"/bank-list"} />

            <div className={styles.termContent}>
              {data?.renderedHtml && <div className={styles.dynamic__content} dangerouslySetInnerHTML={{ __html: data.renderedHtml }} />}
              {/* <div className={styles.dynamic__content} dangerouslySetInnerHTML={{ __html: data?.renderedHtml }}></div> */}
            </div>
          </div>

          <div className={styles.acceptTermFooter}>
            <div className={styles.disbursalBankAccount}>
              <h6>Disbursement Bank Account</h6>
              <div className={styles.bankList}>
                <div className={styles.bankLogo}>
                  <img src={data?.bankDetails?.bankLogo} alt="" />
                </div>
                <div>
                  <p>{data?.bankDetails?.accountNo}</p>
                  <span>{data?.bankDetails?.bankName}</span>
                </div>
              </div>
            </div>
            <div className={styles.accept}>
              <div>
                <Checkbox
                  {...label}
                  checked={checkTerm}
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                  onChange={(e) => setCheckTerm(e.target.checked)}
                />
              </div>
              <div>
                I acknowledge, that I have read and understood the Key Fact Statement and agreement mentioned therein and confirm that I hold the bank
                account mentioned above. I take full responsibility for the correctness of all provided information.
              </div>
            </div>

            <div className={styles.buttonWrapper}>
              <CustomButton floating={false} text="I Accept" disabled={!checkTerm} onClick={() => handleKeyFactStatus()} />
            </div>
          </div>
        </div>
      </div>

      {/* OTP Modal */}
      <OtpModal
        open={openOtpModal} // This should be controlled by your state logic
        handleClose={() => setOpenOtpModal(false)} // Define your close handler
        length={6}
        message={apiResponseMsg}
        resetMsg={setApiResponseMsg}
        handleSubmit={(otp) => {
          handleKeyFactStatus(otp);
        }}
      />
    </>
  );
}
